import { http } from '../../../../api/http';
import type { OrdenCompra } from '../types/ordenCompra.types';

export class OrdenCompraService {
  private static readonly BASE = '/compras/orden-compra';

  public static async getAll(): Promise<OrdenCompra[]> {
    const response = await http.get(this.BASE);
    return response.data;
  }

  public static async getById(id: number): Promise<OrdenCompra> {
    const response = await http.get(`${this.BASE}/${id}`);
    return response.data;
  }

  public static async save(data: OrdenCompra): Promise<OrdenCompra> {
    const response = await http.post(this.BASE, data);
    return response.data;
  }

  public static async delete(id: number): Promise<boolean> {
    await http.delete(`${this.BASE}/${id}`);
    return true;
  }

  public static async aprobar(id: number, idUsuarioAprueba: number): Promise<OrdenCompra> {
    const response = await http.post(`${this.BASE}/${id}/aprobar?idUsuarioAprueba=${idUsuarioAprueba}`);
    return response.data;
  }
}
